export class Country {
  id?: number;
  description: string;
  code: string;
  phoneCode: string;
  name?: string;
}
